const SESSION_STRINGS = {
  HREF: 'resi-software-encoder-href',
};

export { SESSION_STRINGS };
